import Toastify from 'toastify-js';

const showToastify = (message, opts) => {
	Toastify({
		duration: 3000,
		position: "center",
		style: { 
			background: "rgba(255, 255, 255, 1)", 
			color: "rgba(24, 25, 30, 1)", 
			boxShadow: `
				0 3px 6px -1px rgba(198, 146, 63, 0.12), 
				0 10px 36px -4px rgba(198, 146, 63, 0.3)
			` 
		},
		text: message,
		...opts
	}).showToast();
}

export default showToastify;
